import { render, staticRenderFns } from "./PaymentLayout.vue?vue&type=template&id=bb0a6c08&"
import script from "./PaymentLayout.vue?vue&type=script&lang=js&"
export * from "./PaymentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports